export default "__VITE_ASSET__BcNZFc8h__"